import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { License } from "src/app/shared/models/license.model";
import { PrinterDeviceItem } from "src/app/shared/models/PrinterDevice.model";

@Component({
	selector: "app-kitchen-device-setup",
	templateUrl: "./kitchen-device-setup.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class KitchenDeviceSetupComponent implements OnInit {
	@Input() kitchenDevice: License;
	@Output() kitchenDeviceChange = new EventEmitter<License>();

	changesToSave: boolean = false;

	printerId: number;

	printerDeviceList: PrinterDeviceItem[];

	availablePrinterId: {
		label: string;
		value: number;
		disabled: boolean;
	}[] = [];

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.printerId = this.kitchenDevice.printerId;
		this.availablePrinterIdGenerate();
		this.getPrinterDevices(this.venueService.venueKey);
	}

	availablePrinterIdGenerate() {
		for (let i = 1; i < 33; i++) {
			const inUseLicense = this.venueService.licensesKitchenDevice.value.find((lic) => lic.printerId === i);
			this.availablePrinterId.push({
				label: inUseLicense ? inUseLicense.name : i.toString(),
				value: i,
				disabled: inUseLicense ? true : false,
			});
		}
	}

	onSave() {
		this.focuslink.licensePut(this.kitchenDevice);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `${this.kitchenDevice.name} settings saved successfully.` });
		const idx = this.venueService.licensesKitchenDevice.value.findIndex((lic) => lic.key === this.kitchenDevice.key);
		this.venueService.licensesKitchenDevice.value[idx] = this.kitchenDevice;
		this.changesToSave = false;
	}

	releaseLicense() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to release license ${this.kitchenDevice.key}?`,
			accept: async () => {
				this.kitchenDevice.claimed = false;
				this.kitchenDevice.mac = null;
				this.kitchenDevice.name = "Unassigned";
				this.kitchenDevice.deviceType = null;
				this.kitchenDevice.softwareVersion = null;
				this.kitchenDevice.printerId = null;
				this.kitchenDevice.stationId = null;
				this.kitchenDevice.updated = new Date();
				this.kitchenDevice.lastUsed = null;
				await this.focuslink.licensePut(this.kitchenDevice);
				const existingKey = this.venueService.licensesKitchenDevice.value.findIndex((i) => i.key === this.kitchenDevice.key);
				this.venueService.licensesKitchenDevice.value[existingKey] = this.kitchenDevice;
				this.kitchenDeviceChange.emit(undefined);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async getPrinterDevices(venueKey: number) {
		await this.focuslink.printerDeviceGetAll(venueKey).then((data) => {
			this.printerDeviceList = data.map((i) => new PrinterDeviceItem(i));
		});
	}
}
